//获取静态资源地址
import { APP_SKIN, STATIC_FILE } from "@/constants/constants";
import { ResConfig } from "@/constants/resConfig";
import { getLangKey } from "@/i18n";
import { configStore } from "@/stores/configStore";
import type { FrontCfgGameConfigData } from "@/types/config";
import { FrontCfgV2Info } from "@/types/swagger/front";

//根据游戏id返回图片地址
export const getGameimgurlByGameId = (
  gameid: number | undefined,
  folder?: string,
  org_icon_folder?: string,
  ext_icon_folder?: string,
  fileType?: "png" | "jpg",
): string => {
  if (!gameid) return "";

  let gameImg_folder = ResConfig["game-icon-folder"];
  const gameIconDomin = ResConfig["game-icon"];
  const domain = gameIconDomin[gameid % gameIconDomin.length];
  const isOringinal =
    Number(gameid) < 100000 || `${gameid}`.substring(1, 4) == "000"; //小于100000自研cocos游戏 或者 游戏id第234位为000 为其他部门自研

  const frontCfg = configStore.frontCfgMap[
    "GameConfig"
  ] as unknown as FrontCfgV2Info; // frontcfg获取全局配置
  const frontCfg_gameconfig_data =
    frontCfg as unknown as FrontCfgGameConfigData;
  if (isOringinal) {
    gameImg_folder =
      folder || //组件自定义目录
      org_icon_folder || //组件自研游戏
      frontCfg_gameconfig_data?.gameFolder || //全局自定义目录
      frontCfg_gameconfig_data?.orgGameFolder || //全局自研游戏目录
      ResConfig["game-icon-folder"]; // 写死默认目录
  } else {
    gameImg_folder =
      folder || //组件自定义目录
      ext_icon_folder || //组件外接游戏
      frontCfg_gameconfig_data?.gameFolder || //全局自定义目录
      frontCfg_gameconfig_data?.extGameFolder || //全局外接游戏目录
      ResConfig["game-icon-folder"];
  }
  const o_id = Number(gameid) < 100000 ? "0" : `${gameid}`.substring(1, 4); //外接游戏 取游戏id 第234位 为目录，自研游戏目录为 0
  const src = `${domain}${gameImg_folder}/${o_id}/${gameid}.${fileType || ResConfig["game-icon-type"]}`;
  return src;
};

//根据模块获取图片地址
// prettier-ignore
export const getImgUrlWithSkin = ( imgname: string, path: string, skin: string = APP_SKIN): string => {
  return `${ResConfig["root-address"]}s_static/${skin}/${path}/${imgname}`;
};
// countryIcon
export const getCountryIconByCurreny = (curreny: string): string => {
  return `${ResConfig["root-address"]}s_static/common/country_icon/${curreny}.svg`;
};

export const getGClassIconByGClass = (gclass: string) => {
  return `${ResConfig["root-address"]}s_static/common/gclassImage/${gclass}.png`;
};

/** 获取头像图片地址 */
// prettier-ignore
export const getHeadImgurl = (headImg: number | string): string => {
  const num = Number(headImg);
  const imgName = isNaN(num) ? 'default.png' : num % 15 +".jpg";
  return `${ResConfig["root-address"]}s_static/common/avatar/h_${imgName}`;
};
export const getImgurl = (imgname: string, path: string): string => {
  return (
    ResConfig["root-address"] +
    "cdn-cgi/image/format=auto/s_static/" +
    path +
    "/" +
    imgname
  );
};

export const getImgurlWithAppName = (
  imgname: string,
  path: string,
  useLanguage: boolean = false,
): string => {
  const root = ResConfig["root-address"];
  const appName = __APP_NAME__;
  const cfPath = "cdn-cgi/image/format=auto/s_static/";
  const imgName = imgname.split(".")[0];
  const imgExt = imgname.split(".")[1];
  if (useLanguage) {
    imgname = `${imgName}_${getLangKey()}.${imgExt}` + "?123";
  }
  path = `${appName}/` + path;
  const url = root + cfPath + path + "/" + imgname;

  return url;
};

export const getFileUrl = (fileName: string, path: string): string => {
  let url =
    ResConfig["root-address"] + "s_static" + "/" + path + "/" + fileName;

  if (fileName.includes(".lottie")) {
    url += "?timestamp=" + Date.now();
  }
  return url;
};

export const getSkinFileUrl = (fileName: string, path: string): string => {
  return ResConfig["root-address"] + "s_static" + path + "/" + fileName;
};

export const getNoLoginBgImage = () => {
  return `${ResConfig["root-address"]}s_static/login/bg_nologin.png`;
};
export const getCountryImage = (acode: string) => {
  return (
    ResConfig["root-address"] +
    `/dev_skin/C02/home/country/area/Area_Code_${acode}.svg?t202411122151`
  );
};
export const getProviderLogo_winner = (logo: string) => {
  if (logo.startsWith("http")) {
    return logo;
  }
  return `${ResConfig["root-address"]}${ResConfig["plat-icon-folder-winner"]}/${logo}.png`;
};
export const getProviderLogo = (logo: string) => {
  if (!logo) return "";
  if (logo.startsWith("http")) {
    return logo;
  }
  return `${ResConfig["root-address"]}${ResConfig["plat-icon-folder"]}/${logo}.png`;
};
export const getUserVip = (level: string) => {
  return `${ResConfig["root-address"]}s_static/common/vip/${level}.png`;
};
export const getVipTag = (level: string) => {
  return `${ResConfig["root-address"]}s_static/common/vip_tag/${level}.png`;
};
export const getGameDefaultImg = () => {
  return `${ResConfig["root-address"]}s_static/${APP_SKIN}/common/GameDefault.png`;
};
export const getCommonImg = (path: string) => {
  return `${ResConfig["root-address"]}s_static/common/${path}`;
};

export const getTournamentImg = (path: string) => {
  return `${ResConfig["root-address"]}s_static/tournament/${path}`;
};

/** 获取组件图片 */
export const getComponentImg = (path: string) => {
  return `${ResConfig["root-address"]}s_static/component/${path}`;
};
/** 获取个人中心图片 */
export const getProfileImg = (path: string) => {
  return `${ResConfig["root-address"]}s_static/profile/${path}`;
};
/** 获取弹窗图片 */
export const getPopupImg = (path: string) => {
  return `${ResConfig["root-address"]}s_static/popup/${path}?20250614`;
};

/** 获取 VIP 升级弹窗图片 */
export const getVipPopupImg = (type: "h5" | "pc") => {
  return `${ResConfig["root-address"]}s_static/popup/vip/${type}-popup.png`;
};

/** 获取 VIP h5-背景图片 */
export const getVipBannerImg = (type: "h5" | "pc") => {
  return `${ResConfig["root-address"]}s_static/vip/${type}-vip-bg.jpg`;
};

export const getVipLevelBannerImg = (level: number, type: "h5" | "pc") => {
  return `${ResConfig["root-address"]}s_static/vip/vip${level}-bg-${type}.png?20250701`;
};

/** 获取 Bonus info 背景图片 */
export const getBonusInfoBgImg = (path: string) => {
  return `${ResConfig["root-address"]}s_static/bonusCenter/${path}.png?123`;
};

/** 获取 Bonus header 图片 */
export const getBonusHeaderImg = () => {
  return `${ResConfig["root-address"]}s_static/bonusCenter/bonus-animation.webp`;
};

/** 获取 Bonus no-login 图片 */
export const getBonusNoLoginImg = (path: string) => {
  return `${ResConfig["root-address"]}s_static/bonusCenter/no-login2/${path}?20251129`;
};

/** 获取 新人七日签到 图片 */
export const getNewCheckInImg = (img: string) => {
  return `${ResConfig["root-address"]}s_static/activity/newCheckIn/${img}`;
};

/** 获取 vip 图片 */
export const getVipActivityImg = (path: string) => {
  return `${ResConfig["root-address"]}s_static/vip2/${path}.png?20250701`;
};

/** 获取 钱包 图片 */
export const getWalletImg = (path: string, img: string) => {
  return `${ResConfig["root-address"]}s_static/wallet/${path}/${img}`;
};

/** 获取 体育 图片 */
export const getSportImg = (path: string) => {
  return `${ResConfig["root-address"]}s_static/sports/${path}`;
};

/** 获取 下载 图片 */
export const getInstallImg = (img: string) => {
  return `${ResConfig["root-address"]}s_static/install/${STATIC_FILE}/${img}?20251114`;
};

/** 获取 落地页 图片 */
export const getLandingPageImg = (path: string, img: string) => {
  return `${ResConfig["root-address"]}s_static/landingPage/${path}/${img}`;
};
